module.exports = __webpack_public_path__ + "static/img/qh1-5.34486c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/qh1-5.png
// module id = 708
// module chunks = 0